import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import { mutator } from 'satcheljs';
import {
    updateSharingLinkFromSharingDialog,
    updateSharingLinkPermission,
} from '../actions/internalActions';
import { onFluidLinkCreated } from '../actions/publicActions';
import getSharingLinkInfo from '../selectors/getSharingLinkInfo';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';

mutator(updateSharingLinkFromSharingDialog, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLinkInfo(actionMessage.linkId);
    sharingLink.permissionLevel = actionMessage.sharingDialogResponse.permissionLevel;
});

mutator(updateSharingLinkPermission, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLinkInfo(actionMessage.linkId);
    sharingLink.permissionLevel = actionMessage.newPermission;
});

// Fluid links should default to recipients of this message permission level for now.
// VSO 84084: use tenant default links instead
mutator(onFluidLinkCreated, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLinkInfo(actionMessage.linkId);
    sharingLink.permissionLevel = AttachmentPermissionLevel.Edit;
});
